import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import React from 'react';
import { unitConverter as uc } from '../../../styles/base';
import Image from '../../atoms/Image/Image';
import sanityImage from '../../../utils/sanityImage';

const IndustrySideBar = ({ content }) => {
  const logosCss = css`
    display: flex; /* for IE11 */
    display: grid;
    flex-wrap: wrap;
    grid-column-gap: ${uc('50px')};
    grid-template-columns: repeat(2, 1fr);
    justify-content: space-between;
    width: ${uc('300px')};
    margin: ${uc('25px auto 0')};
    padding: ${uc('20px 0')};

    img {
      flex: 1 0 50%;
      align-self: center;
      justify-self: center;
      max-height: ${uc('60px')};
      margin-bottom: ${uc('25px')};
    }
  `;
  return (
    <div css={logosCss}>
      {content.logos.map(logo => (
        <Image
          src={sanityImage(logo)
            .height(60)
            .fit('max')
            .url()}
          key={`logo-component-${logo._key}`}
          alt="company logo"
          title="company logo"
        />
      ))}
    </div>
  );
};

/**
 * Prop types
 */
IndustrySideBar.propTypes = {
  content: PropTypes.shape({ logos: {} }),
};

/**
 * Default props
 */
IndustrySideBar.defaultProps = {
  content: {},
};

export default IndustrySideBar;
